import { render, staticRenderFns } from "./FieldLevelPermissions.vue?vue&type=template&id=702f57c7"
import script from "./FieldLevelPermissions.vue?vue&type=script&lang=js"
export * from "./FieldLevelPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports